/**
 * function called on changes in selector's created sub-state
 * @callback OnChangeCallback
 * @param {any} newValue
 * @param {any} oldValue
 * @param {function(): State} getState
 * @return {void}
 */

/**
 * @typedef StoreSubscriber
 * @property {function(Accessor, OnChangeCallback): remove} add
 * 		Add watcher to value returned from Selector,
 * 		return method to stop watching.
 * @property {function(Accessor, OnChangeCallback): void} remove
 * 		Stop watch to value returned from Selector.
 * @property {function(): void} dispose
 * 		Drop all watcher and unsubscribe from store.
 */

export default createSubscriber;

/**
 * @param {Store} store
 * @return {StoreSubscriber}
 */
function createSubscriber (store) {
	const callbacks = new Map();
	const values = new Map();

	const unsubscribe = store.subscribe(function () {
		const state = store.getState();
		values.forEach((oldValue, selector) => {
			const newValue = selector(state);
			if (newValue === oldValue) {
				return;
			}
			values.set(selector, newValue);

			callbacks.get(selector).forEach((cb) => {
				cb(newValue, oldValue, store);
			});
		});
	});

	return {
		add,
		remove,
		dispose(){
			callbacks.clear();
			values.clear();
			unsubscribe();
		},
	};

	/**
	 *
	 * @param {Accessor} accessor
	 * @param {OnChangeCallback} cb
	 * @return {function(): void}
	 */
	function add (accessor, cb) {
		/*
		const state = store.getState();
		const value = accessor(state);
		const valueType = typeof value;
		// TODO: я видел мельком что в mqtt похожая проверка сделана без includes, если нам критично важно избежать ES5, то надо будет переделать
		const isValidType = value === null || ['boolean', 'string', 'number'].includes(valueType);
		if(!isValidType) {
			throw new Error('Subscriber support only primitives');
		}
*/
		if (callbacks.has(accessor)) {
			callbacks.get(accessor).push(cb);
		} else {
			callbacks.set(accessor, [cb]);
		}

		if (false === values.has(accessor)) {
			values.set(accessor, accessor(store.getState()));
		}

		return () => remove(accessor, cb);
	}

	/**
	 *
	 * @param {Accessor} accessor
	 * @param {OnChangeCallback} cb
	 */
	function remove (accessor, cb) {
		callbacks.set(accessor, callbacks.get(accessor).filter((_cb_) => cb !== _cb_));
	}
}
